<div [formGroup]="mainForm">
        <h6 class="form-header h6-icon">
          {{ 'RELATIONS.EDITDIALOG.FORM.HEADER.CUSTOMERINFO' | translate }}
        </h6>

        <div class="row">
          <div class="col">
            <div class="row">
              <div class="form-group col-4">
                <label class="form-control-label">
                  {{ 'RELATIONS.EDITDIALOG.FORM.HEADER.CUSTOMERTYPE' | translate }}@if (mainForm.get('CustomerType').hasValidator(requiredValidator)) {
                  <span class="tx-danger">*</span>
                }
              </label>
              <ng-select [items]="customerTypes" bindLabel="viewValue" bindValue="value"
                formControlName="CustomerType" placeholder="{{ 'RELATIONS.EDITDIALOG.FORM.PLACEHOLDER.CUSTOMERTYPE' | translate }}" [clearable]="false"
              notFoundText="{{'GENERIC.EDITDIALOG.PLACEHOLDER.NOITEMSFOUND' | translate}}" appendTo="body"></ng-select>
              <t4-display-validation controlName="CustomerType" [form]="mainForm" [messages]="validationMessages">
              </t4-display-validation>
            </div>

            @if (mainForm.controls.CustomerType.value == '1') {
              <div class="form-group col-8">
                <label class="form-control-label">
                  {{ 'RELATIONS.EDITDIALOG.FORM.HEADER.ACCOUNTMANAGER' | translate }}@if (mainForm.get('AccountManagerId').hasValidator(requiredValidator)) {
                  <span class="tx-danger">*</span>
                }
              </label>
              <ng-select [items]="accountManagers" bindLabel="Name" bindValue="Id" formControlName="AccountManagerId"
                placeholder="{{ 'RELATIONS.EDITDIALOG.FORM.PLACEHOLDER.ACCOUNTMANAGER' | translate }}" [clearable]="false" notFoundText="{{'GENERIC.EDITDIALOG.PLACEHOLDER.NOITEMSFOUND' | translate}}" appendTo="body">
              </ng-select>
              <t4-display-validation controlName="AccountManagerId" [form]="mainForm"
              [messages]="validationMessages"></t4-display-validation>
            </div>
          }
        </div>

        <div class="row">
          @if (mainForm.controls.CustomerType.value == '1') {
            <div class="form-group col-4">
              <label class="form-control-label">
                {{ 'RELATIONS.EDITDIALOG.FORM.LABEL.COMPANYNAME' | translate }}@if (mainForm.get('Name').hasValidator(requiredValidator)) {
                <span class="tx-danger">*</span>
              }
            </label>
            <input class="form-control" name="name" formControlName="Name">
            <t4-display-validation controlName="Name" [form]="mainForm" [messages]="validationMessages">
            </t4-display-validation>
          </div>
        }

        @if (mainForm.controls.CustomerType.value == '1') {
          <div class="form-group col-4">
            <label class="form-control-label">
              {{ 'RELATIONS.EDITDIALOG.FORM.LABEL.KVK' | translate }} @if (mainForm.get('COC').hasValidator(requiredValidator)) {
              <span class="tx-danger">*</span>
            }
          </label>
          <input class="form-control" name="coc" formControlName="COC">
        </div>
      }

      @if (mainForm.controls.CustomerType.value == '1') {
        <div class="form-group col-4">
          <label class="form-control-label">
            {{ 'RELATIONS.EDITDIALOG.FORM.LABEL.VAT' | translate }}@if (mainForm.get('VATNr').hasValidator(requiredValidator)) {
            <span class="tx-danger">*</span>
          }
        </label>
        <input class="form-control" name="name" formControlName="VATNr">
      </div>
    }
  </div>
  <div class="row">
    <div class="form-group col-4">
      <label class="form-control-label">
        {{ 'RELATIONS.EDITDIALOG.FORM.LABEL.TELEPHONE' | translate }}@if (mainForm.get('TelephoneNr').hasValidator(requiredValidator)) {
        <span class="tx-danger">*</span>
      }
    </label>
    <input class="form-control" name="TelephoneNr" formControlName="TelephoneNr">
    <t4-display-validation controlName="TelephoneNr" [form]="mainForm" [messages]="validationMessages">
    </t4-display-validation>
  </div>

  @if (mainForm.controls.CustomerType.value == '1') {
    <div class="form-group col-4">
      <label class="form-control-label">
        {{ 'RELATIONS.EDITDIALOG.FORM.LABEL.EXTERNALCODE' | translate }}@if (mainForm.get('ExternalCode').hasValidator(requiredValidator)) {
        <span class="tx-danger">*</span>
      }
    </label>
    <input class="form-control" name="ExternalCode" formControlName="ExternalCode">
    <t4-display-validation controlName="ExternalCode" [form]="mainForm" [messages]="validationMessages">
    </t4-display-validation>
  </div>
}
</div>
</div>
</div>
</div>
